var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading_page)?[_c('section',{staticClass:"body-sign center-body"},[_c('div',{staticClass:"center-box-sign"},[_c('ring-loader',{attrs:{"height":_vm.loading_size}})],1)])]:_vm._e(),(!_vm.loading_page)?[(_vm.user_auth)?[_c('geoloc-component')]:[_c('login-component')]]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }